import { z } from "zod";

export const getCreateReviewFormSchema = () => {
	return z.object({
		partnerId: z.number(),
		rating: z.string().nonempty(),
		description: z.string(),
	});
};

export type CreateReviewFormModel = z.infer<
	ReturnType<typeof getCreateReviewFormSchema>
>;
